<template>
  <b-collapse
    :id="'technical-info-' + result._id"
    :visible="visible"
    @show="on_show"
  >
    <b-overlay :show="loading">
      <div class="product-technical-info">
        <b-row>
          <b-col
            class="product-technical-info-section"
            v-if="info.producer_note"
          >
            <h4>Producer</h4>
            <div v-html="info.producer_note"></div>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col class="product-technical-info-section" v-if="info.winemaking">
            <h4>Winemaking</h4>
            <div v-html="info.winemaking"></div>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col
            class="product-technical-info-section"
            v-if="info.tasting_note"
          >
            <h4>Tasting Note</h4>
            <div v-html="info.tasting_note"></div>
            <div
              class="mb-2"
              v-if="
                info.tasting_note_reviewer &&
                info.tasting_note_reviewer !== 'Jeroboams'
              "
            >
              <strong> Reviewer: </strong> {{ info.tasting_note_reviewer }} -
              {{ info.tasting_note_source }}
            </div>
            <div class="mb-2" v-else-if="info.tasting_note_reviewer">
              <strong> Reviewer: </strong> {{ info.tasting_note_reviewer }}
            </div>
            <div class="row">
              <div class="col-6">
                <div
                  class="mb-2"
                  v-if="
                    info.tasting_note_reviewer &&
                    info.tasting_note_date !== '0000-00-00'
                  "
                >
                  <strong> Date: </strong> {{ info.tasting_note_date }}
                </div>
              </div>
              <div class="col-6 text-right">
                <wishlist-add-button
                  v-if="showWishlist && isLoggedIn"
                  :result="result"
                ></wishlist-add-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col
            class="product-technical-info-section"
            v-if="info.foodmatching"
          >
            <h4>Food Matching</h4>
            <div v-html="info.foodmatching"></div>
          </b-col>
        </b-row> -->
      </div>
    </b-overlay>
  </b-collapse>
</template>

<script>
import jbs_api from "@/modules/jbs-api";
import WishlistAddButton from "@/components/WishlistAddButton";

export default {
  components: {
    WishlistAddButton,
  },
  props: {
    showWishlist: {
      type: [Boolean],
      default: false,
    },
    result: {
      type: [Boolean, Object],
      default: false,
    },
    productInformation: {
      type: [Boolean, Object],
      default: false,
    },
    visible: {
      type: [Boolean],
      default: false,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      info: false,
    };
  },
  mounted() {
    if (this.visible && !this.productInformation) {
      this.loading = true;
      this.fetch_info();
    } else if (this.productInformation) {
      this.info = this.productInformation;
    }
  },
  methods: {
    on_show() {
      if (!this.info) {
        this.loading = true;

        this.fetch_info();
      }
    },
    fetch_info() {
      jbs_api
        .get("product-information", { params: { id: this.result._id } })
        .then((response) => {
          this.info = response.data;
          this.loading = false;
        });
    },
  },
};
</script>
